import { ReactNode, useEffect, useRef, useState } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  forceZero?: boolean;
}

export const AnimatedHeight = ({ children, className, forceZero = false }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      setHeight(ref.current?.offsetHeight || 0);
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    setIsMounted(true);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      className={`animated-height ${isMounted ? 'animated-height--animated' : ''} ${className}`}
      style={{ height: forceZero ? '0px' : height === undefined ? 'auto' : `${height}px` }}
    >
      <div ref={ref}>{children}</div>
    </div>
  );
};
